import { Icon, IconKey } from '@qred/qit-ui';
import React from 'react';
import { HelpItemWrapper, IconContainer } from './HelpSection.styled';
import { Body } from '@qred/components-library';

interface HelpItemProps {
  icon: IconKey;
  text: string;
  element?: any;
  href?: string;
  onClick?: () => void;
}

const HelpItem = ({ icon, text, element, href, onClick }: HelpItemProps) => (
  <HelpItemWrapper as={element} href={href} onClick={onClick}>
    <IconContainer>
      <Icon size="lg" src={icon} color="white" />
    </IconContainer>
    <Body size="lg">{text}</Body>
  </HelpItemWrapper>
);

export default HelpItem;
